import createActions from '../config/actions/createActions';
import { action } from '@play-co/replicant';
import { getPlayerProfile } from '../profile/profile.getters';
import { getEquippedPetSpecies } from '../pet/pet.getters';
import { species } from '../pet/pet.ruleset';
import { GENERIC_AVATAR } from '../profile/assets';

/** Development mode only, not allowed in production  */
export const friendsCheats = createActions({
  cheat_clearFriends: action((state) => {
    state.buruFriends = {};
    state.friendshipRequests = {};
  }),

  cheat_clearFriendshipRequests: action((state) => {
    state.friendshipRequests = {};
  }),

  cheat_addDummyFriendshipRequest: action((state, _, api) => {
    const index = Object.keys(state.friendshipRequests).length + 1;
    const id = `Udummy-friend${index}`;

    const ownProfile = getPlayerProfile(
      state,
      state.publicProfile?.name,
      state.publicProfile?.photo,
    );

    // Generate a random name from 3 to 16 characters
    const randomNameLength = Math.floor(Math.random() * 14) + 3; // 3 to 16
    const chars = 'abcdefghijklmnopqrstuvwxyz';
    let randomName = '';
    for (let i = 0; i < randomNameLength; i++) {
      randomName += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    // Capitalize first letter
    randomName = randomName.charAt(0).toUpperCase() + randomName.slice(1);

    state.friendshipRequests[id] = {
      owner: {
        id,
        name: randomName,
        profilePicture: GENERIC_AVATAR,
        frame: 'default',
        species: species[Math.floor(Math.random() * species.length)],
      },
      target: {
        id: state.id,
        name: ownProfile.name,
        profilePicture: ownProfile.photo,
        frame: 'default',
        species: getEquippedPetSpecies(state) ?? 'ball',
      },
      status: 'pending',
      createdAt: api.date.now(),
      updatedAt: api.date.now(),
    };
  }),

  cheat_clearDummyFriends: action((state, _, api) => {
    for (const friendId in state.buruFriends) {
      if (friendId.startsWith('Udummy')) {
        delete state.buruFriends[friendId];
      }
    }

    for (const friendId in state.friendshipRequests) {
      if (friendId.startsWith('Udummy')) {
        delete state.friendshipRequests[friendId];
      }
    }
  }),
});
